import { core } from '../core/index.js';

export type FabricToastShowSpinnerOptions = {
  /**
   * 是否显示背景遮罩层, 默认显示, 遮罩层会覆盖住navbar.
   * @default true
   */
  mask?: boolean;
  /**
   * 自定义加载标题
   */
  title?: string;
  /**
   * 针对Android有效, 当前打开的spinner, 点击back键是否连同当前webview一起关闭.
   * @default false
   */
  backCloseWithHostView?: boolean;
};

export type FabricToastCloseSpinnerOptions = {
  /**
   * 当前关闭toast loading 动画是否清空全部计数器, 关闭. 因为toast是可以多次调用, 每次计数器+1
   * 只显示一个
   * @default false
   */
  closeAll?: boolean;
};

export type FabricToastShowSpinnerApi = (
  options?: FabricToastShowSpinnerOptions
) => void;

export type FabricToastCloseSpinnerApi = (
  options?: FabricToastCloseSpinnerOptions
) => void;

/**
 * 针对页面Ajax, 显示Native spinner 动画
 * @param options
 */
export const showSpinner: FabricToastShowSpinnerApi = (
  options: FabricToastShowSpinnerOptions = {
    /**
     * 默认有遮罩层, Note:遮罩层会覆盖住navbar
     */
    mask: true,
    /**
     * 标题
     */
    title: '',
    /**
     * 针对Android有效, 当前打开的spinner, 点击back键是否连同当前webview一起关闭.
     * 默认false, 硬件back只关闭一次spinner, 不关闭宿主webview, 如果为true, 一次back相当于会清空所有的spinner计数器.并销毁webview
     */
    backCloseWithHostView: false,
  }
) => {
  core.call<'fabric_toast.showSpinner', FabricToastShowSpinnerOptions>(
    'fabric_toast.showSpinner',
    options
  );
};

/**
 * 针对页面Ajax, 关闭Native spinner 动画
 */
export const closeSpinner = (
  options: FabricToastCloseSpinnerOptions = {
    closeAll: false,
  }
) => {
  core.call<'fabric_toast.closeSpinner', FabricToastCloseSpinnerOptions>(
    'fabric_toast.closeSpinner',
    options
  );
};
